import { render, staticRenderFns } from "./DesignChangeDialog.vue?vue&type=template&id=27347bc1"
import script from "./DesignChangeDialog.vue?vue&type=script&lang=js"
export * from "./DesignChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./styles/design-change-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/design-list.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports